export enum TenantSelfServeMigrationEvent {
    CancelMigration = 'TenantSelfServeMigration.CancelMigration',
    OpenMigration = 'TenantSelfServeMigration.OpenMigration',
    ReadMore = 'TenantSelfServeMigration.ReadMore',
    RequestMigration = 'TenantSelfServeMigration.RequestMigration',
    SelectMigrationWindow = 'TenantSelfServeMigration.SelectMigrationWindow',
    SelectNewRegion = 'TenantSelfServeMigration.SelectNewRegion',
    ViewMigrationDetails = 'TenantSelfServeMigration.ViewMigrationDetails',
}
